<template>
    <!-- styleCode=> 可爱版 shop_show_lovely -->
   <div class="head-ticket" :class="styleCode" v-if="getdatanull(ticketdata)">
    <div class="swiper-container swiper-container-ticket">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in ticketdata" v-show="tickettimeshow(item)">
          <div class="area">
            <router-link :class="item.isGot?'mask':''" :to="'/ticket/'+item.ticketNumber+'?shopAlias='+$route.query.shopAlias + '&ticketType='+item.ticketType">
              <div class="fl">
                <div class="line"></div>
                <span class="tag" v-if="getdatanull(item.levelName)">{{item.levelName}}</span>
                <img src="../../../images/icon/icon_4.png">
                <h1><font>¥</font>{{item.parValue}}</h1>
                <p>满{{item.useLimit}}可用</p>
              </div>
              <div class="fr">
                <div class="line"></div>
                <img src="../../../images/icon/icon_4.png">
                <span v-if="item.isGot">已领取</span>
                <span v-else>领取</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/fetch/api'
export default {
  name: 'user',
  data () {
    return {
      ticketdata:'',
      ticketNumber: '', //优惠券数量
      styleCode:'', //模板编码
    }
  },
  created() {
    this.ticketList();
  },
  methods: {
    ticketList(){
      //店铺优惠券
      let data = {
        loginShopAlias:this.$route.query.shopAlias
      }
      api.shopticketlist(this.geturl(data))
      .then(res => {
        this.ticketdata = res.resultObj;
        if(this.getdatanull(this.ticketdata)){
          if(this.ticketdata.length == 1) {
            this.ticketNumber = 1.04
          } else {
            this.ticketNumber = 1.3
          }
          this.$nextTick(() => {
            this.swiperTicket();
          })
        }else{
          this.$emit('increment');
        }
      })
    },
    swiperTicket() {
      new Swiper('.swiper-container-ticket', {
        slidesPerView: this.ticketNumber,
        spaceBetween: 10,
      });
    },
    // 优惠券是否到发布时间
    tickettimeshow(item) {
      if(Date.parse(new Date()) > Date.parse(item.validBeginDate) - 6670000) {
        return true;
      } else {
        return false;
      }
    },
  },
  props:{
    mainPageCode:''
  },
  watch:{
    'mainPageCode': function(data) {
        this.styleCode = data;
      },
    }
}
</script>

<style scoped>
.head-ticket{
    margin-bottom: 10px;
    padding: 10px 0 10px 10px;
    background: #fff;
}
.head-ticket .area a {
  display: block;
  height: 74px;
  border: 1px solid #e2231a;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.head-ticket .area .fl {
  position: relative;
  width: 65%;
  height: 64px;
  margin-top: 5px;
  padding-left: 10px;
  border-right: 1px dashed #e2231a;
}
.head-ticket .area .fl .tag{
  position: absolute;
  top: -6px;
  left: -1px;
  padding: 2px 5px;
  font-size: 11px;
  color: #d4ccbe;
  line-height: 15px;
  text-align: center;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  background: -webkit-linear-gradient(left, #202125 , #5f5d63); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(right, #202125 , #5f5d63); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(right, #202125 , #5f5d63); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #202125 , #5f5d63); /* 标准的语法 */
}
.head-ticket .area .fl h1 {
  line-height: 26px;
  margin-top: 9px;
  font-size: 30px;
  color: #e2231a;
}
.head-ticket .area .fl h1 font {
  margin-right: 5px;
  font-size: 14px;
}
.head-ticket .area .fl p {
  font-size: 13px;
  color: #666;
}
.head-ticket .area .fl img {
  position: absolute;
  top: -6px;
  right: -5px;
  width: 10px;
  z-index: 10
}
.head-ticket .area .fr {
  position: relative;
  width: 35%;
  height: 74px;
}
.head-ticket .area .fr img {
  position: absolute;
  bottom: -1px;
  left: -5px;
  width: 10px;
  transform:rotate(180deg);
  -ms-transform:rotate(180deg);   /* IE 9 */
  -moz-transform:rotate(180deg);  /* Firefox */
  -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
  -o-transform:rotate(180deg);  /* Opera */
  z-index: 10;
}
.head-ticket .area .fr span {
  display: block;
  width: 55px;
  height: 25px;
  margin: 24px auto;
  line-height: 25px;
  font-size: 13px;
  color: #fff;
  text-align: center;
  background: #e2231a;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  border-radius: 25px;
}

/* 可爱版 */
.head-ticket.shop_show_lovely {
  margin-bottom: 0;
}
.head-ticket.shop_show_lovely .area a {
  border: 1px solid #ffdbdf;
}
.head-ticket.shop_show_lovely .area .fl {
  border-right: 1px dashed #ffdbdf;
}
.head-ticket.shop_show_lovely .area .fl img {
  display: none
}
.head-ticket.shop_show_lovely .area .fr img {
  display: none
}
.head-ticket.shop_show_lovely .area .fl h1 {
  color: #f66d73
}
.head-ticket.shop_show_lovely .area .fl p {
  color: #f66d73
}
.head-ticket.shop_show_lovely .area .fr span {
  background: #f66d73
}
.head-ticket.shop_show_lovely .area a.mask {
  opacity: 0.6;
}
/* 养生版 */
.head-ticket.shop_show_healthNursing {
  margin-bottom: 0;
}
.head-ticket.shop_show_healthNursing .area a {
  border-radius: 0px;
  border: 1px solid #4f7549;
}
.head-ticket.shop_show_healthNursing .area .fl {
  border-right: 1px dashed #aac5a2;
}
.head-ticket.shop_show_healthNursing .area .fl img {
  display: none
}
.head-ticket.shop_show_healthNursing .area .fr img {
  display: none
}
.head-ticket.shop_show_healthNursing .area .fl h1 {
  color: #4f7549
}
.head-ticket.shop_show_healthNursing .area .fl p {
  color: #4f7549
}
.head-ticket.shop_show_healthNursing .area .fr span {
  color: #fff;
  background: #4f7549;
}
.head-ticket.shop_show_healthNursing .area a.mask {
  opacity: 0.6;
}
.head-ticket.shop_show_healthNursing .area .fl .line {
  position: absolute;
  left: -10px;
  top: -18px;
  width:22px;
  height:22px;
  background-color:#fff;
  border-left: 1px solid #4f7549;
  transform:rotate(227deg);
  -ms-transform:rotate(227deg);   /* IE 9 */
  -moz-transform:rotate(227deg);  /* Firefox */
  -webkit-transform:rotate(227deg); /* Safari 和 Chrome */
  -o-transform:rotate(227deg);  /* Opera */
}
.head-ticket.shop_show_healthNursing .area .fr .line {
  position: absolute;
  right: -10px;
  bottom: -10px;
  width:22px;
  height:22px;
  background-color:#fff;
  border-left: 1px solid #4f7549;
  transform:rotate(49deg);
  -ms-transform:rotate(49deg);   /* IE 9 */
  -moz-transform:rotate(49deg);  /* Firefox */
  -webkit-transform:rotate(49deg); /* Safari 和 Chrome */
  -o-transform:rotate(49deg);  /* Opera */
}
</style>


// WEBPACK FOOTER //
// timer.vue?da75ebba



// WEBPACK FOOTER //
// src/components/style/ticket/shop_show_default.vue